<!--积分明细-->
<template>
  <div class="consum-box fs18 cr">
<!--    <div class="select-box mb15">-->
<!--      <el-date-picker-->
<!--        v-model="times"-->
<!--        type="daterange"-->
<!--        range-separator="至"-->
<!--        start-placeholder="开始日期"-->
<!--        end-placeholder="结束日期"-->
<!--        value-format="yyyy-MM-dd"-->
<!--        :picker-options="pickerOptions"-->
<!--      />-->
<!--      <el-button class="ml10" type="primary" @click="select()">查询</el-button>-->
<!--    </div>-->
    <p class="fs22 bold">积分明细</p>
    <el-table
      ref="multipleTable"
      v-loading="tableLoading"
      :header-cell-style="{ background: '#F5F7FA' }"
      :data="tableData"
      style="width: 100%"
      stripe
      border
    >
      <!--      <el-table-column prop="index" label="序号" align="center" />-->
      <!--      <el-table-column-->
      <!--        prop=""-->
      <!--        label="标题"-->
      <!--        align="center"-->
      <!--      />-->
      <!--      <el-table-column prop="" label="用户名" align="center" />-->
      <el-table-column prop="expire_time" label="有效期" align="center" />
      <el-table-column prop="credits" label="可使用积分" align="center" />
    </el-table>
<!--    <el-pagination-->
<!--      class="page-box mt10"-->
<!--      :current-page="selectObj.page"-->
<!--      :page-sizes="[10, 20, 30, 40]"-->
<!--      :page-size="selectObj.limit"-->
<!--      layout="total, sizes, prev, pager, next, jumper"-->
<!--      :total="total"-->
<!--      @size-change="handleSizeChange"-->
<!--      @current-change="handleCurrentChange"-->
<!--    />-->
  </div>
</template>
<script>
  import { credits } from '../api/user'
  export default {
    name: '',
    computed: {
      theme() {
        return this.$store.getters.getTheme;
      }
    },
    data() {
      return {
        tableData: [], // 表格内容,
        selectObj: {
          start_date: '',
          end_date: '',
          page: 1,
          limit: 999,
        },
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now()
          },
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }]
        },
        times: [],
        tableLoading: false,
        total: null
      }
    },
    created() {
      this.getList()
    },
    methods: {
      select() {
        this.selectObj.page = 1
        this.getList(this.selectObj)
      },
      getList() {
        if (this.times) {
          this.selectObj.start_time = this.times[0]
          this.selectObj.end_time = this.times[1]
        }
        this.tableLoading = true
        credits({ ...this.selectObj }).then(res => {
          this.tableData = res.data.details
          this.total = res.data.total
          this.tableLoading = false
        }).catch(error => {
          this.$message.error(error.msg)
          this.tableLoading = false
        })
      },
      // 分页的操作
      handleSizeChange(val) {
        this.selectObj.limit = val
        this.getList(this.selectObj)
      },
      handleCurrentChange(val) {
        this.selectObj.page = val
        this.getList(this.selectObj)
      }
    },
    /**加载完组件时执行(加载完成之后执行)*/
    mounted() {
    },
  }
</script>

<style lang="scss" scoped>
  .consum-box::-webkit-scrollbar {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }
  .consum-box {
    background-color: #fff;
    box-shadow: 0 4px 12px 4px #0000000d;
    box-sizing: border-box;
    width: 100%;
    padding: 24px;
    height: calc(100vh - 95px - 50px);
    overflow-y: scroll;
    overflow-x: hidden;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* Internet Explorer 10+ */
    border-radius: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/moreCredits.vue